import moment from 'moment';
import React, { useState, useEffect } from 'react'
import { Line } from 'react-chartjs-2';
import { useTranslation } from "react-i18next";

const SensorHistoryChart = ({ data }) => {

  const [state, setState] = useState(null)
  const { t, i18n } = useTranslation();


  const getChartData = () => {
    let labels = []
    let solarRad = []
    let lang = i18n.language === 'ar' ? 'ar' : i18n.language === 'fr' ? 'fr' : 'en';
    data && data.map(solarData => {
      let date = solarData.date
      solarRad.push(parseFloat(solarData.value).toFixed(2))
      labels.push(moment(date.slice(0, 10)).locale(lang).format('ddd, h a'))
      // labels = ([...new Set(labels)])
    })
      ;
    const state = {
      labels: labels,
      datasets: [
        {
          label: t('solar_radiation'),
          lineTension: 0.5,
          borderWidth: 2,
          data: solarRad,
          fill: false,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "#d66915"
        },



      ]
    }
    setState(state)
  }

  useEffect(() => {
    getChartData()
  }, [data,i18n.language])

  const hasData = state && state.labels && state.labels.length > 0;

  return (
    <>
      {hasData ? (
        <Line
          data={state}
          options={{
            plugins: {
              title: {
                display: true,
                text: `${t('week_solar_radiation')}`,
                fontSize: 20
              },
              legend: {
                display: true,
                position: 'bottom'
              },
            }

          }}
        />
      ) : (
        <p className="text-center text-muted mt-4">
          {t("no_data", { defaultValue: "No sensor history found for this period." })}
        </p>
      )}
    </>

  )
}

export default SensorHistoryChart